import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQ_KEY_SUBSTRING_LENGTH = 30;

const FAQ = ({ t }) => {
  return (
    <section className="py-20 px-4 bg-navy-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-navy-900 mb-4">{t.faq.title}</h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {t.faq.items.map((faq, index) => (
            <AccordionItem key={`faq-${index}-${faq.question.substring(0, FAQ_KEY_SUBSTRING_LENGTH)}`} value={`item-${index}`} className="bg-white mb-4 rounded-lg border-navy-100 px-6">
              <AccordionTrigger className="text-left text-navy-900 font-semibold hover:text-navy-700">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;